<template>
  <div class="main-container">
    <div id="container" class="xiexinChangePowerMap"></div>

    <!-- 搜索 -->
    <div class="search-box flex align-center">
      <div class="area">
        {{cityName}}
      </div>
      <van-icon name="arrow-left" class="back-icon" @click="goBack()" v-if="this.isApp == 4"/>
    	<div class="search flex justify-between align-center">
        <input :focus="true"
                @blur="inputConfirm"
               @confirm="inputConfirm"
               confirm-type="search"
               @keyup.enter="inputConfirm"
               :adjust-position="false"
               type="text" placeholder-class="search-pla" placeholder="目的地/电站/关键字"
               v-model="searchValue"
        ></input>
    		<img @click="inputConfirm" src="https://sass.gclme.com/api/file/Image/annex/20220105_09247b22879142e98d3ff8e32cf67029.png" class="search-img" />
      </div>
    </div>
    <div class="search-list" @click="goBackMini">
      <img class="buttom-img-map" src="https://sass.gclme.com/api/file/Image/annex/20240202_c191a4307fcb4d4ab15acc0d85fd276c.png" alt="">
      列表
    </div>


<div class="station-detail">
  <van-swipe @change="openInfo" :initial-swipe="initNumbber" :show-indicators="false" duration="1000">
    <van-swipe-item v-for="(item,index) in stationAllList"  :key="index" class="swip-item"  >
  <div class="container-list">
    <div class="container-list-top flex">
      <div class="left flex1">
        <div>
          <div class="list-right" >
              <div class="title">{{item.stationName ? item.stationName : item.name}}</div>
            <div class="right-contan flex">
              <div class="cu-newitem">
                <div>{{item.type == '0e1f49d1b90c4036989d3545ec8d0966' ? '直流快充' : '交流慢充'}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="right-bottom flex">
          <div class="change-price" >
            <span>{{item.electricityPrice ? item.electricityPrice :'-'}}</span>
            元起
          </div>
        </div>
      </div>
      <div class="right">
        <div class="bottom-change">
          <div class="can-change">
            <div class="mainspan" v-if="item.slowGunNumAvailable">
                <img class="tips" src="https://sass.gclme.com/api/file/Image/annex/20240130_069dad34904e445394462622665df151.png" alt="">

              <span class="gunnumber gunnumber1"> {{item.slowGunNumAvailable ? item.slowGunNumAvailable : '0'}}</span> <span class="all">/ {{item.slowGunNum ? item.slowGunNum : '0'}}</span>
            </div>
            <div class="mainspan fast" v-if="item.fastGunNumAvailable">
                <img class="tips" src="https://sass.gclme.com/api/file/Image/annex/20240130_9108cc3b62674be5a390b4960a3883c2.png" alt="">
              <span class="gunnumber gunnumber2"> {{item.fastGunNumAvailable ? item.fastGunNumAvailable : '0'}}</span> <span class="all">/ {{item.fastGunNum ? item.fastGunNum : '0'}}</span>
            </div>
            <!-- <div class="mainspan exfast">
                <img class="tips" src="https://sass.gclme.com/api/file/Image/annex/20240130_4ca318d402b8486db496cd05ba08300c.png" alt="">
              <span class="gunnumber gunnumber3">0</span> <span class="all">/ 0</span>
            </div> -->
          </div>
        </div>
        </div>

    </div>



    <div class="stop-bottom">
      <div class="left">
        <span class="tips">P</span>
        {{item.parkingChargeInformation || '以实际停车场收费信息为准！'}}
      </div>
      <div class="right"  v-if="isApp == 1" @click="goUniapp('map',item)">
        <div class="navitive">
          <img class="img" src="https://sass.gclme.com/api/file/Image/annex/20240130_88660a4132fa48d0a1c690536842bc5b.png" alt="">
          {{item.distance}}
          <span class="unit">km</span>
        </div>
      </div>
      <div class="right" v-else @click="chooseMap(item)">
        <div class="navitive">
          <img class="img" src="https://sass.gclme.com/api/file/Image/annex/20240130_88660a4132fa48d0a1c690536842bc5b.png" alt="">
          {{item.distance}}
          <span class="unit">km</span>
        </div>
      </div>
    </div>
  </div>

  </van-swipe-item>
  </van-swipe>
</div>


      <!-- <div class="container-list-main" v-if="showList">
        <template v-if="stationAllList.length>0">
          <div v-for="(item,index) in stationAllList" :key="index" class="swip-item"  >
            <div class="container-list">
              <div class="container-list-top flex">
                <div class="left flex1">
                  <div>
                    <div class="list-right" @click="goUniapp('detail',item)">
                        <div class="title">{{item.stationName ? item.stationName : item.name}}</div>
                      <div class="right-contan flex" v-if="item.availableGan">
                        <div class="cu-newitem">
                          <div>{{item.type == '0e1f49d1b90c4036989d3545ec8d0966' ? '直流快充' : '交流慢充'}}</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="right-bottom flex">
                    <div class="change-price" >
                      <span>{{item.electricityPrice ? item.electricityPrice :'-'}}</span>
                      元起
                    </div>
                  </div>
                </div>
                <div class="right">
                  <div class="bottom-change">
                    <div class="can-change">
                      <div class="mainspan">
                          <img class="tips" src="https://sass.gclme.com/api/file/Image/annex/20240130_069dad34904e445394462622665df151.png" alt="">

                        <span class="gunnumber gunnumber1"> {{item.slowGunNumAvailable ? item.slowGunNumAvailable : '0'}}</span> <span class="all">/ {{item.slowGunNum ? item.slowGunNum : '0'}}</span>
                      </div>
                      <div class="mainspan fast">
                          <img class="tips" src="https://sass.gclme.com/api/file/Image/annex/20240130_9108cc3b62674be5a390b4960a3883c2.png" alt="">
                        <span class="gunnumber gunnumber2"> {{item.fastGunNumAvailable ? item.fastGunNumAvailable : '0'}}</span> <span class="all">/ {{item.fastGunNum ? item.fastGunNum : '0'}}</span>
                      </div>
                      <div class="mainspan exfast">
                          <img class="tips" src="https://sass.gclme.com/api/file/Image/annex/20240130_4ca318d402b8486db496cd05ba08300c.png" alt="">
                        <span class="gunnumber gunnumber3">0</span> <span class="all">/ 0</span>
                      </div>
                    </div>
                  </div>
                  </div>

              </div>



              <div class="stop-bottom">
                <div class="left">
                  <span class="tips">P</span>
                  {{item.parkingChargeInformation}}
                </div>
                <div class="right"  v-if="isApp == 1" @click.stop="goUniapp('map',item)">
                  <div class="navitive">
                    <img class="img" src="https://sass.gclme.com/api/file/Image/annex/20240130_88660a4132fa48d0a1c690536842bc5b.png" alt="">
                    {{item.distance}}
                    <span class="unit">KM</span>
                  </div>
                </div>
                <div class="right" v-else @click.stop="chooseMap(item)">
                  <div class="navitive">
                    <img class="img" src="https://sass.gclme.com/api/file/Image/annex/20240130_88660a4132fa48d0a1c690536842bc5b.png" alt="">
                    {{item.distance}}
                    <span class="unit">KM</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div style="display: flex;flex-direction:column;justify-content: center;align-items: center">
            <img
              src="https://sass.gclme.com/api/file/Image/annex/20240105_64e4dc7c8ee0476c9b1e3a4e475d8d08.png"
              width="40%"
              alt=""
            >
            <div style="font-size: 14px;">暂无数据~</div>
          </div>
        </template>
      </div> -->
  </div>
</template>
<script type="text/javascript">
// import AMapLoader from '@amap/amap-jsapi-loader';
import { Toast } from 'vant';
import  VueBottomSheetVue2 from "@webzlodimir/vue-bottom-sheet-vue2";

export default {
  name: 'charingmap',
  components: {
    VueBottomSheetVue2
  },
  data() {
    return {
      imgUrl: 'https://sass.gclme.com/api/file/Image/annex/20240130_1ee98081c1524e6690081ed90928d0d2.png',
      overflowType: 'hidden',
      screenY: 0,
      cityName: '',
      showList: false,
      map : null,
      AMap : null,
      AMapUI : null,
      initNumbber: 0,
      token : null,
      baseurl : null,
      stationAllListObj:{},
      infoWindow:'',
      stationAllList: [], // 所有的站点列表
      stationCovers: [],  // 站点集合
      layer : null,   // 点标记
      actionAdress : {},   // 地址
      location : [116.379028, 39.865042],  // 定位
      driving : null,  // 规划的路线
      objectMarkerList : null,   // markerList对象
      licensePlate : null,  // 车牌号码
      carList : [],  // 附近车辆列表
      // 搜索相关
      searchValue: '',
      searchList: [], // 搜索结果页
      isGetList: false,
      longitude: null, //经度
      latitude: null, //纬度
      sheetShow: false,
      actions : [
        { id:1, name: '高德地图' },
        { id:2, name: '百度地图' },
        { id:3, name: '腾讯地图' },
      ],
      showTab: true,
      zoomSize: 10,
      elscroll: '',
      shooseSearchItem : null,   // 搜索选中的对象
      isApp : 1,
      markPointList: [],
      isZoomMap: 'small',
       stationTypes:'', // 过滤数据
       locations:'',
       city:'',
       isDefault:'',
       scrollTop: 0,
       touchStartY: 0,
       startscreenY: 0,
       startscreenY1: 0,
       isTop: true,
    }
  },
  computed:{
  },
  mounted() {
    this.elscroll = document.getElementById('output');
  },
  created() {
    let _this = this;
    document.title = "站点地图"
    this.licensePlate = this.$route.query && this.$route.query.licensePlate ? this.$route.query.licensePlate : null;
    this.token=this.$route.query.token ? this.$route.query.token : "bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiIxODEwMDUiLCJzY29wZSI6WyJhbGwiXSwic2luZ2xlTG9naW4iOiIyIiwiZXhwIjoxNjYxNDUxNzkwLCJhdXRob3JpdGllcyI6WyJhYSJdLCJqdGkiOiJlZTdkZjA3ZS0wNDc2LTQ2YWQtODA5OS02MWQyNmY1YWUzMTEiLCJjbGllbnRfaWQiOiJhZG1pbiIsInRva2VuIjoiZ2NsbG9naW5fdG9rZW5fOWUxNmExYjAyYzgxNGI3NTg2MWM3NTAyY2JmZDNiYzEifQ.O7gcJ2YvMvIhkEDPEOB1eWBw-ucK3hU380yFiWtfll-tJCJNtO8L_S4oKQL3cyRBsOPpUtdpot5GTZtVs3JOeSsKA_gV3ll9npKaUiOc2PGojzEmYXwJNrJzDRjNMb721sgESoYobZWc6ilCZG5r0EVhbRhiwg3-l6wQLe1_QP60Grf4SQ1a-Jlg7iMp7jdS_sivC0i80E_PibTfpoIv_hPdEfXoQe7DJcE0BRNpdcke0pN7dG85iI86lXY6m5E02tyvclivnj549Rg7vuRL351cnRILLnrZWxImXNGErsya1ZNWSeaMVbz77FwneSYvvk2VDIcdOU7mBVu9dyqvIg";
    this.location=this.$route.query.location ? this.$route.query.location.split(",") : [116.379028, 39.865042];
    this.cityName=this.$route.query.city
    // 'bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX25hbWUiOiIxODcwMTMxODIwNyIsInNjb3BlIjpbImFsbCJdLCJleHAiOjE2NTczMDM2MTksImF1dGhvcml0aWVzIjpbImFhIl0sImp0aSI6ImI3OTZmZGVlLWZlZjctNDk3MS1hMDA2LTQ0OGZhMDFlOGJjMyIsImNsaWVudF9pZCI6ImFkbWluIiwidG9rZW4iOiJnY2xsb2dpbl90b2tlbl8zYzI1NmIyMGQxZGI0ZTczYjJmNDExZmFmNGU1YTA5YyJ9.DA8NNwAvraJMQYg0J23T1xNNhRqxj_--ZFpEIQEsDldIbBYt6H3Q6jdgJ2jg8YRaQnpCHjCwEjjniSil0jZM79a_lAZkdj1QPDvEQgt8FFLmjr86m3gxBF4ePQz5jWdN4F7AMh8aBZ3wvOc3D5KMudQJ1JQCga_cUl1-1VtUACK_bu5uYHW99w4ejwauVknPWiv1xbjwIDDM0i1R8qdm1ZAvQZo3uNjZ9EewRRoUmMasn0rd4mXA_vComgVW4-PJoP4FopT5TQIIUria-De_Xb3l7KZfsZttyW16Un3gw7LI717NNoE_jLafTjaR2veIDgLj4B4JnxAC2KNXrXBABg';
    this.baseurl=this.$route.query.baseurl ? this.$route.query.baseurl : 'https://sass.gclme.com';
    this.isApp=this.$route.query.isApp ? this.$route.query.isApp : 1;
    window._AMapSecurityConfig = {
      securityJsCode: '5d52d08f659664f824f5021ef237b1c0'
    }
    var elem = document.createElement("script");
    elem.src = "https://webapi.amap.com/maps?v=2.0&key=3c323c18d7f2d237ba10b4f06c5a1648&plugin=AMap.Driving,AMap.Geolocation";
    document.body.appendChild(elem);
    elem.onload = elem.onreadystatechange = function () {
        if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
          var elemUI = document.createElement("script");
          elemUI.src = "https://webapi.amap.com/ui/1.1/main.js";
          document.body.appendChild(elemUI);
          elemUI.onload = elemUI.onreadystatechange = function () {
              if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
                _this.getList()
              }
          }
        }
    }

  },
  watch: {
    searchValue: {
      immediate: true,
      handler() {
        this.isGetList = false
      }
    },
    isZoomMap:{
      handler(newval, oldvale){
        this.changeIcon()
      }
    }
  },
  methods: {
    changList() {
      this.showList = !this.showList
      if(this.showList) {
        this.imgUrl = 'https://sass.gclme.com/api/file/Image/annex/20240130_654c93bd164741dc83f4dbca4b372671.png'
      } else {
        this.imgUrl = 'https://sass.gclme.com/api/file/Image/annex/20240130_1ee98081c1524e6690081ed90928d0d2.png'
      }
    },
    // H5返回
    goBack(){
      window.history.go(-1)
    },
    goBackMini() {
      wx.miniProgram.navigateBack()
    },
      goUniapp (page,item){
        let _this = this;
        let data = {}
        if(page == 'detail'){
          // 判断是充电桩还是换电站
          if(item.availableGan) {
            //充电站
            data = {
              page : "rechargedetail",
              item : item
            }
          } else {
            //换电站
            data = {
              page : "detail",
              item : item
            }
          }

        }else if(page == 'map'){
          data = {
            page : "map",
            item : item,
            actionAdress : this.actionAdress
          }
        }
        uni.postMessage({
            data: {
                action: data
            }
        });
      },

      changeIcon(init) {
        let _this = this
        _this.map.remove(_this.markPointList)

        // 添加一些分布不均的点到地图上,地图上添加三个点标记，作为参照
        _this.stationAllList.forEach(function(marker) {

          if(_this.zoomSize >= 14) {
            // 点标记显示内容，HTML要素字符串

                    var markerContent = `<div style="padding:0.12rem 0.2rem;background-color: #ffffff;width: 3.2rem;font-size: 0.3rem;border-radius:0.2rem">
                        <div class="markerproject" style="display:none">${JSON.stringify(marker)}</div>
                        <div >
                            <span>
                              <span  style="color:rgba(25, 128, 255, 1);font-weight:600;">
                              <img style="width:0.5rem;transform: translate(0.02rem, 0.1rem)" class="tips" src="https://sass.gclme.com/api/file/Image/annex/20240130_9108cc3b62674be5a390b4960a3883c2.png" alt="">
                              </span>
                              <span style="color:rgba(25, 128, 255, 1);font-weight:600"> ${marker.fastGunNumAvailable ? marker.fastGunNumAvailable : '0'}</span><span>/${marker.fastGunNum ? marker.fastGunNum : '0'}</span>
                            </span>
                            <span>
                              <span  style="color:rgba(13, 192, 248, 1);font-weight:600">
                              <img style="width:0.5rem;transform: translate(0.02rem, 0.1rem)" class="tips" src="https://sass.gclme.com/api/file/Image/annex/20240130_069dad34904e445394462622665df151.png" alt="">
                              </span>
                              <span   style="color:rgba(13, 192, 248, 1);font-weight:600"> ${marker.slowGunNumAvailable ? marker.slowGunNumAvailable : '0'}</span><span >/${marker.slowGunNum ? marker.slowGunNum : '0'}</span>
                            </span>
                        </div>
                      <div  style="height: 0.5rempx;line-height:0.5rem;color:rgba(255, 82, 69, 1)">
                        <span style="font-size:0.4rem;">${marker.electricityPrice ? marker.electricityPrice :'-'}</span>
                        元起
                      </div>

                      <div class="kailong"></div>
                    </div>`

                    var markerContent1 = `<div style="padding:0.13rem 0.24rem;box-shadow: #9b9b9b 3px 3px 3px;background-color: #e3f0fe;width: 3.2rem;font-size: 0.3rem;border-radius:0.2rem">
                        <div class="markerproject" style="display:none">${JSON.stringify(marker)}</div>
                        <div >
                            <span>
                              <span  style="color:rgba(25, 128, 255, 1);font-weight:600;">
                              <img style="width:0.5rem;transform: translate(0.02rem, 0.1rem)" class="tips" src="https://sass.gclme.com/api/file/Image/annex/20240130_9108cc3b62674be5a390b4960a3883c2.png" alt="">
                              </span>
                              <span style="color:rgba(25, 128, 255, 1);font-weight:600"> ${marker.fastGunNumAvailable ? marker.fastGunNumAvailable : '0'}</span><span>/${marker.fastGunNum ? marker.fastGunNum : '0'}</span>
                            </span>
                            <span>
                              <span  style="color:rgba(13, 192, 248, 1);font-weight:600">
                              <img style="width:0.5rem;transform: translate(0.02rem, 0.1rem)" class="tips" src="https://sass.gclme.com/api/file/Image/annex/20240130_069dad34904e445394462622665df151.png" alt="">
                              </span>
                              <span   style="color:rgba(13, 192, 248, 1);font-weight:600"> ${marker.slowGunNumAvailable ? marker.slowGunNumAvailable : '0'}</span><span >/${marker.slowGunNum ? marker.slowGunNum : '0'}</span>
                            </span>
                        </div>
                      <div  style="height: 0.5rempx;line-height:0.5rem;color:rgba(255, 82, 69, 1)">
                        <span style="font-size:0.4rem;">${marker.electricityPrice ? marker.electricityPrice :'-'}</span>
                        元起
                      </div>

                      <div class="kailong"></div>
                    </div>`
          }else {
            // 点标记显示内容，HTML要素字符串
                var markerContent = `<div  style="width: 1.2rem;height: 1.2rem;">
                    <div class="markerproject" style="display:none">${JSON.stringify(marker)}</div>
                   <img style="width: 100%;height: 100%;" src="https://sass.gclme.com/api/file/Image/annex/20220719_1e4070d31cd94e1baf66410461a7c573.png">
                   </div>`

                   var markerContent1 = `<div  style="width: 1.9rem;height: 1.9rem;">
                       <div class="markerproject" style="display:none">${JSON.stringify(marker)}</div>
                      <img style="width: 100%;height: 100%;" src="https://sass.gclme.com/api/file/Image/annex/20240202_ecdc8f70839b4270858e89e078f0649e.png">
                      </div>`
          }




          try{
            _this.infoWindow.close()
          }catch(e){
            //TODO handle the exception
          }
          var markPoint = new AMap.Marker({
                map: _this.map,
                content: markerContent,
                offset: {x: -22,y: -25},
                position: [marker.longitude, marker.latitude]
            });
            markPoint.content  =  markerContent1
            _this.markPointList.push(markPoint)





            // 2. 给这个 Marker 添加点击事件
            markPoint.on('click', mapEvent => {
              if(_this.zoomSize >= 14) {
                _this.infoWindow = new AMap.InfoWindow({
                   isCustom: true,  //使用自定义窗体
                   offset: new AMap.Pixel(40, 47)
                })


              } else {
                _this.infoWindow = new AMap.InfoWindow({
                   isCustom: true,  //使用自定义窗体
                   offset: new AMap.Pixel(4, 49)
                })
                // infoWindow.close()
              }


              _this.infoWindow.setContent(mapEvent.target.content);
              _this.infoWindow.open(_this.map, mapEvent.target.getPosition());
              try{
                _this.stationAllListObj = JSON.parse(mapEvent.target.dom.getElementsByClassName('markerproject')[0].innerText)
                console.log(_this.stationAllListObj)
                _this.showTab = false


                _this.stationAllList.forEach((item, index) => {
                  if(_this.stationAllListObj.id == item.id) {
                    _this.initNumbber = index
                  }
                   _this.showTab = true
                })


              }catch(e){
                //TODO handle the exception
              }

            })
        });


      },
      openInfo(index) {
        let _this = this
        let marker = _this.stationAllList[index]
          //构建信息窗体中显示的内容
          if(_this.zoomSize >= 14) {
            // 点标记显示内容，HTML要素字符串
                    var changeInfoHtml = `<div style="padding:0.13rem 0.24rem;box-shadow: #9b9b9b 3px 3px 3px;background-color: #e3f0fe;width: 3.2rem;font-size: 0.3rem;border-radius:0.2rem">
                        <div class="markerproject" style="display:none">${JSON.stringify(marker)}</div>
                        <div >
                            <span>
                              <span  style="color:rgba(25, 128, 255, 1);font-weight:600;">
                              <img style="width:0.5rem;transform: translate(0.02rem, 0.1rem)" class="tips" src="https://sass.gclme.com/api/file/Image/annex/20240130_9108cc3b62674be5a390b4960a3883c2.png" alt="">
                              </span>
                              <span style="color:rgba(25, 128, 255, 1);font-weight:600"> ${marker.fastGunNumAvailable ? marker.fastGunNumAvailable : '0'}</span><span>/${marker.fastGunNum ? marker.fastGunNum : '0'}</span>
                            </span>
                            <span>
                              <span  style="color:rgba(13, 192, 248, 1);font-weight:600">
                              <img style="width:0.5rem;transform: translate(0.02rem, 0.1rem)" class="tips" src="https://sass.gclme.com/api/file/Image/annex/20240130_069dad34904e445394462622665df151.png" alt="">
                              </span>
                              <span   style="color:rgba(13, 192, 248, 1);font-weight:600"> ${marker.slowGunNumAvailable ? marker.slowGunNumAvailable : '0'}</span><span >/${marker.slowGunNum ? marker.slowGunNum : '0'}</span>
                            </span>
                        </div>
                      <div  style="height: 0.5rempx;line-height:0.5rem;color:rgba(255, 82, 69, 1)">
                        <span style="font-size:0.4rem;">${marker.electricityPrice ? marker.electricityPrice :'-'}</span>
                        元起
                      </div>

                      <div class="kailong"></div>
                    </div>`
          }else {
            // 点标记显示内容，HTML要素字符串
                   var changeInfoHtml = `<div  style="width: 1.9rem;height: 1.9rem;">
                       <div class="markerproject" style="display:none">${JSON.stringify(marker)}</div>
                      <img style="width: 100%;height: 100%;" src="https://sass.gclme.com/api/file/Image/annex/20240202_ecdc8f70839b4270858e89e078f0649e.png">
                      </div>`
          }


          if(_this.zoomSize >= 14) {
            _this.infoWindow = new AMap.InfoWindow({
               isCustom: true,  //使用自定义窗体
               offset: new AMap.Pixel(40, 47),
               content: changeInfoHtml  //使用默认信息窗体框样式，显示信息内容
            })


          } else {
            _this.infoWindow = new AMap.InfoWindow({
               isCustom: true,  //使用自定义窗体
               offset: new AMap.Pixel(4, 49),
               content: changeInfoHtml  //使用默认信息窗体框样式，显示信息内容
            })
            // infoWindow.close()
          }

          let obj = _this.map.getCenter()


            obj.kT = marker.latitude,
            obj.KL = marker.longitude,
            obj.lat = marker.latitude,
            obj.lng = marker.longitude,


          _this.infoWindow.open(_this.map, obj);
      },
      initMap(){
        let _this = this;

       //初始化地图对象，加载地图
            _this.map = new AMap.Map("container", {
              resizeEnable: true,
              center:[_this.stationAllListObj.longitude, _this.stationAllListObj.latitude],
              zoom: 14
              });


           _this.map.setFitView();
           _this.changeIcon('init')
           _this.openInfo(0)
           _this.initNumbber = 0
       // 监听地图缩放事件，根据缩放级别设置infowindow的显示或隐藏状态
       function mapZoomstart(){
               _this.zoomSize = _this.map.getZoom()


           }
           function mapZoomend(){
             _this.zoomSize = _this.map.getZoom()
               if(_this.map.getZoom() >=14) {
                 _this.isZoomMap = 'big'
               } else {
                 _this.isZoomMap = 'small'
               }


           }

           _this.map.on('zoomstart', mapZoomstart);
           _this.map.on('zoomend', mapZoomend);
      },
      debounce(fn, delay) {
          let timeout = null;
          return function() {
              clearTimeout(timeout);
              timeout = setTimeout(() => {
                  fn.apply(this, arguments);
              }, delay);
          }
      },
      getQueryVariable(variable){
          var query = window.location.href.split('charingmap?')[1];
          var vars = query.split("&");
          for (var i=0;i<vars.length;i++) {
              var pair = vars[i].split("=");
              if(pair[0] == variable){return pair[1];}
          }
          return(false);
      },
      // 获取充电站列表
      async getPileStationList(){
        let _this = this;
        let locationArr = this.getQueryVariable('location')
        let longitude = locationArr ? locationArr.split(',')[0] : ''
        let latitude = locationArr ? locationArr.split(',')[1] : ''
        var header ={
          'X-Access-Token': ''
        }
        if(this.token){
          header ={
            'authorization': this.token
          }
        }
        Toast.loading({
          message: '正在获取您附近的站点...',
          forbidClick: true,
          // duration : 0
        });
        try {
          const { data } = await this.$http({
            method : 'get',
            url : `${this.baseurl}/api/station/stationData/pileList`,
            headers:header,
            params: {
              "tenant": "gcl",
              "longitude": longitude,
              "latitude": latitude,
              "city":_this.city!=false?  decodeURIComponent( decodeURIComponent(_this.city)): '',
              'stationName': this.searchValue,
              'onlyShowOpeningStation' : 1
            }
          });
          this.stationAllList = []
          data.data.forEach(item => {
            if(item.longitude && item.latitude) {
              this.stationAllList.push(item)
            }
          })

          if(this.stationAllList) {
            this.stationAllListObj = this.stationAllList[0] || {}
            this.initMap()
          }


          Toast.clear();
        } catch (err) {
          Toast.clear();
        }
      },
      initPage(MarkerList) {},
      // 搜索相关功能
      InputBlur(e) {
        this.searchValue = e && e.currentTarget && e.currentTarget.value
          this.getList();
      },
      inputConfirm(e) {
        this.getList();
      },
      search(item) {
        this.getList();
      },
      getList() {
        this.getPileStationList()
      },
      // 搜索相关功能
      chooseMap(item){
        let _this = this;
        if(this.isApp == 3 || this.isApp == 4){
        //打开地图，商家位置导航
            var mini=false;
            let itemstationName = item.stationName ? item.stationName : item.name
            if(_this.isApp == 3){
              wx.miniProgram.getEnv(function(res){
                  if (res.miniprogram){
                    wx.miniProgram.navigateTo({url: "/package/pages/mapwebview/locationMapwebview?latitude="+ item.latitude +"&longitude="+ item.longitude +"&address="+ item.detailedAddress + "&stationName=" + itemstationName});
                  }
              });
            }else{
              wx.miniProgram.navigateTo({
                url: "/pages/electro_map/electro_map?latitude="+ item.latitude +"&longitude="+ item.longitude +"&address="+ item.detailedAddress + "&stationName=" + itemstationName,
                success: function(res) {
                  console.log('navigateTo success:', res)
                },
                fail: function(res) {
                  console.log('navigateTo fail:', res)
                },
                complete: function(res) {
                  console.log('navigateTo complete:', res)
                }
              });
            }
            mini=true;
        }else{
          this.shooseSearchItem = item;
          this.sheetShow = true;
        }
      }
}
}
</script>

<style>
.bottom-sheet__main {
  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
<style lang="stylus" scoped>
  @import "./charingmap.scss";
</style>



// WEBPACK FOOTER //
// charingmap.vue?488e7202